import React, { useEffect } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";         
import "datatables.net-dt/css/dataTables.dataTables.min.css"; 
export default function MyWinnings(){

    const HOSTNAME = import.meta.env.VITE_API_URL;
    const X_API_KEY = import.meta.env.VITE_X_API_KEY;
    const token = localStorage.getItem('token');
    const user =  JSON.parse(localStorage.getItem("user")) || null;

    async function loadWinningsData() {
        return new Promise((resolve, reject) => {
            let inputObj = user?.user_id || null;
            if (!inputObj) return resolve();

            if ($.fn.DataTable.isDataTable('#winnings-table')) {
                $('#winnings-table').DataTable().clear().destroy();
            }
            
            $('#winnings-table').DataTable({

                "stateSave": false,
                "bDestroy": true,
                "bPaginate": true,
                "ordering": false,
                "serverSide": true,
                "bAutoWidth": false,
                "deferRender": true,
                "scrollCollapse": true,
                "searching": false,
                "lengthMenu": [10, 20, 30, 50],
                "lengthChange": false,
                "orderable": false,
                // "order": [[0, 'desc']],
                "language": {
                    "emptyTable": "No data available",
                },
                "ajax": {
                    url: `${HOSTNAME}/api/mywinnings`,
                    headers: { "x-api-key": X_API_KEY, 'Authorization': "Bearer " + token },
                    data: { inputObj },
                    type: 'POST',
                    dataType: 'json',
                    error: function (xhr, error, thrown) {

                        let message = "Something went wrong.";

                        switch (xhr.status) {
                            case 429:
                                message = "Too many requests. Please wait.";
                                break;
                            case 500:
                                message = "Server error. Try again later.";
                                break;
                            case 403:
                                message = "Access denied.";
                                break;
                            case 0:
                                message = "Network error. Check internet.";
                                break;
                        }

                        const table = $('#leaderboard-data').DataTable();

                        // Update empty message dynamically
                        table.settings()[0].oLanguage.sEmptyTable = message;

                        // Clear table to trigger empty message
                        table.clear().draw();
                    }
                },

                "columns": [
                    // { "data": "rank", orderable: false },
                    { "data": "crd_on", orderable: false, "targets": 0 },
                    { "data": "source", orderable: false },
                    { "data": "reward", orderable: false },
                ],
                "columnDefs": [
                    { "targets": 2, "className": "dt-body-left dt-head-left" }
                ],
                "initComplete": function (settings, json) {
                    const table = $('#winnings-table').DataTable();
                    setTimeout(() => table.columns.adjust().draw(false), 0);
                },
                "error": function (xhr, error, code) {
                    console.error("Error loading winnings data:", error);
                    resolve(); // Resolve the promise even if there's an error
                }
            });

        });
    }

    useEffect(()=>{
        loadWinningsData();
        return () => {
            if ($.fn.DataTable.isDataTable('#winnings-table')) {
                $('#winnings-table').DataTable().clear().destroy();
            }
        };
    },[])



     return (
        <>
            <style>{`
                #winnings-data {
                    overflow-x: auto;
                    scrollbar-gutter: stable;
                }
                #winnings-data .dataTables_wrapper {
                    width: 100%;
                    overflow-x: auto;
                    scrollbar-gutter: stable;
                }
                #winnings-table {
                    border-collapse: collapse !important;
                    width: 100% !important;
                    table-layout: auto;
                }
                #winnings-table th,
                #winnings-table td {
                    border: 1px solid #2d3034 !important;
                    padding: 10px 12px !important;
                    vertical-align: middle;
                }
                #winnings-table th,
                #winnings-table td {
                    white-space: normal !important;
                    word-break: break-word;
                    overflow-wrap: anywhere;
                }
            `}</style>
            <div className="row" >
                {/* <div className='col-2'></div> */}
                <div className='col-12 col-lg-8 offset-lg-2 table-responsive' id='winnings-data'>
                    <table id="winnings-table" className="profile-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Source</th>
                                <th>Reward</th>
                                {/* <th>Reward</th> */}
                            </tr>
                        </thead >
                    </table>
                </div>
            </div>
        </>
    )
}
